import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'


class CreateBloc {

    regionCountryChannel = new Subject();
    regionProvinceChannel = new Subject();
    regionCityChannel = new Subject();
    createChannel = new Subject();
    repository = new CreateRepository()

    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
    }

    fetchRegionCountry = async (query) => {
        this.regionCountryChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchRegionCountry(query).then((result) => {
            this.regionCountryChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.regionCountryChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchRegionProvince = async (query) => {
        this.regionProvinceChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchRegionProvince(query).then((result) => {
            this.regionProvinceChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.regionProvinceChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchRegionCity = async (query) => {
        this.regionCityChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchRegionCity(query).then((result) => {
            this.regionCityChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.regionCityChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchCreate = async (query) => {
        this.createChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchCreate(query).then((result) => {
            this.createChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.createChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
}

export default CreateBloc